import { render } from "./players_list.vue?vue&type=template&id=b60b0466"
import script from "./players_list.vue?vue&type=script&lang=js"
export * from "./players_list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__